import { Component } from '@angular/core';

@Component({
  selector: 'mpp-my-air-label',
  templateUrl: './my-air-label.component.html',
  styleUrls: ['./my-air-label.component.scss'],
  standalone: false,
})
export class MyAirLabelComponent {}
